<template>
  <div>
    <el-divider content-position="left">{{ $t('receivablePayable.otherRules') }}</el-divider>

    <div class="feet-r">
      <!-- 增加一行 -->
      <el-button
        size="small"
        type="primary"
        @click="handleAdd"
      >{{ $t('basicData.AddAdditionalRules') }}</el-button>

      <!-- 下载/导入 -->
      <importAndDownloadCmp
        :business-type="businessType"
        :subregion-list="subregionList"
        :stitching-line="stitchingLine"
        :fee-list="specialFeeList"
        :quotation-type="isQuotationMethod"
        :get-data-func="onDownloadOffer"
        @importList="onImportList"
      />
      <!-- 清空报价 -->
      <el-popover placement="bottom-start" trigger="hover">
        <!-- 清空当前分区 -->
        <div class="feet">
          <el-button
            v-if="isQuotationMethod"
            size="small"
            type="primary"
            @click="clearOffers(1)"
          >{{ $t('basicData.EmptyCurrentPartition') }}
          </el-button>
          <!-- 清空所有分区 -->
          <el-button
            class="feet-btn"
            size="small"
            type="primary"
            @click="clearOffers(2)"
          >{{ $t('basicData.EmptyAllPartitions') }}
          </el-button>
        </div>
        <!--清空报价-->
        <template #reference>
          <el-button
            size="small"
            plain
          >{{ $t('basicData.ClearTheOffer') }}
          </el-button>
        </template>
      </el-popover>
    </div>

    <!--没有选择分区/车线 -->
    <TableCmp
      v-if="!isQuotationMethod"
      ref="defaultTableRef"
      :fee-list="specialFeeList"
      :table-data="partitionArr"
      @change="changeDefaultPartition"
    />

    <!--选择了分区 -->
    <TableCmp
      v-else
      ref="tableRef"
      :fee-list="specialFeeList"
      :table-data="getPartitionArr"
      @change="changePartition"
    />

  </div>
</template>

<script>
import { validatePrice, SEPARATOR } from './utils';
import { ROW_TMP } from './consts';

// 提交模板
const TEM_ROW = {
  'offerPriceId': undefined, // id 提交的时候需要
  'partitionId': null, // 分区id
  'partitionAffiliateId': null, // 分区关联id
  'feeTypeCode': 'PT022',
  'businessType': 0, // 业务类型
  'deliveryFeeRatio': '',
  'specialRules': 1 // 暂时写死
};

export default {
  components: {
    TableCmp: () => import('./TableCmp.vue'),
    importAndDownloadCmp: () => import('./importAndDowloadCmp.vue')
  },

  props: {
    // 业务类型
    businessType: {
      type: [Number, String],
      required: true
    },
    // 报价id
    ids: {
      type: Number,
      default: 0
    },
    // 分区方案id
    partitionId: {
      type: [Number, String],
      default: () => {
        return 0;
      }
    },
    // 当前分区id/车线ID
    partitionAffiliateId: {
      type: [String, Number],
      default: ''
    },
    // 分区明细
    subregionList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 车线明细
    stitchingLine: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 特殊费用
    specialFeeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // table数据
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 报价类型 1 车线报价 2 通用报价
    quotationType: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      // 如果没有选择分区
      partitionArr: [],

      // 如果选择了分区
      partitionObj: {
        // 分区id1: { arr: [] },
        // 分区id2: { arr: [] },
      },

      // 新增：缓存待处理的数据列表
      pendingDataList: []
    };
  },

  computed: {
    partitionComputed() {
      const a = this.partitionId;// 分区方案id
      const b = this.subregionList;// 所有子分区
      const c = this.stitchingLine; // 所有车线数据
      const d = this.quotationType; // 报价类型 1 车线报价 2 通用报价
      return {
        a, b, c, d
      };
    },

    // 判断是否为运输业务
    isTransportBusiness() {
      return this.businessType === 5;
    },

    // 是否有分区方案-true 表示有分区方案 否则无分区方案
    isHasPartition() {
      return !!this.partitionId;
    },

    // 是否存在分区/车线 true-无分区/车线 否则有分区/车线
    isHasPartitionAffiliate() {
      const id = this.partitionAffiliateId;
      return id === '' || id === 0 || id === '0' || id == null;
    },

    // true-表示有车线报价 否则通用报价
    isQuotationMethod() {
      // 是否选择分区
      const hasValidPartition = !this.isHasPartitionAffiliate;

      // 干支线业务-有partitionAffiliateId-车线报价，反之通用报价
      if (this.isTransportBusiness) {
        return hasValidPartition && this.quotationType === 1;
      }
      // 非干支线业务，有分区方案-分区报价，反之通用报价
      return this.isHasPartition && hasValidPartition;
    },

    // 当前车线/分区明细
    getPartitionArr() {
      if (this.isQuotationMethod) {
        return this.partitionObj[this.partitionAffiliateId]?.arr || [];
      }
      return [];
    },

    // 新增：判断分区数据是否已初始化
    isPartitionDataReady() {
      // 车线报价初始化
      if (this.isQuotationMethod) {
        return this.subregionList.length > 0 || this.stitchingLine.length > 0;
      }

      return true;
    }
  },

  watch: {
    // 监听切换方案/分区/车线变化需要重新初始化
    partitionComputed: {
      handler(newVal, oldVal) {
        // 首次执行时 oldVal 为 undefined，直接执行初始化
        if (!oldVal) {
          this.init(this.pendingDataList);
          return;
        }

        // 非首次执行，进行浅比较
        const hasChanged =
          newVal.a !== oldVal.a || // partitionId
          newVal.b.length !== oldVal.b.length || // subregionList 长度
          newVal.c.length !== oldVal.c.length || // stitchingLine 长度
          newVal.d !== oldVal.d;

        if (hasChanged) {
          this.init(this.pendingDataList);
        }
      },
      deep: true,
      immediate: true
    },

    // 详情回调数据渲染
    dataList: {
      handler(val) {
        if (val.length === 0) {
          this.pendingDataList = []; // 清空缓存
          return;
        }

        // 如果分区数据未初始化完毕，缓存数据
        if (!this.isPartitionDataReady) {
          console.log('暂未初始化，缓存数据等待初始化', val);
          this.pendingDataList = [...val]; // 缓存数据副本
          return;
        }

        // 分区数据已准备好，直接处理
        this.init(val);
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    // 初始化分区
    // list: 待处理数据
    async init(list) {
      await this.dataCb();

      // 如果有待处理的数据，执行设置数据
      if (list.length > 0) {
        this.setData(list);
      }
    },

    dataCb() {
      // 【优化】直接替换对象，提高性能
      this.partitionObj = {};
      this.partitionArr = [];

      const initPartition = (arr) => {
        arr.forEach(item => {
          this.$set(this.partitionObj, item.id, { arr: [] });
        });
      };

      // 车线报价
      if (this.isQuotationMethod) {
        const list = this.isTransportBusiness ? this.stitchingLine : this.subregionList;

        if (!list.length) {
          return;
        }

        initPartition(list);
      }

      console.log('其他规则-报价初始化完成', this.partitionObj, this.partitionArr);
    },

    // 增加一行
    handleAdd() {
      // 车线报价
      if (this.isQuotationMethod) {
        if (this.isHasPartitionAffiliate || !this.partitionObj[this.partitionAffiliateId]) {
          // 未选择分区/车线
          return;
        }
        // 已选择分区/车线：添加到对应分区
        this.partitionObj[this.partitionAffiliateId].arr.push({ ...ROW_TMP });
      } else {
        // 通用报价
        this.partitionArr.push({ ...ROW_TMP });
      }
    },

    // 默认分区
    changeDefaultPartition(arr) {
      this.partitionArr = arr;
    },

    // 选择分区
    changePartition(arr = []) {
      if (arr.length === 0) { return; }
      this.partitionObj[this.partitionAffiliateId].arr = arr;
    },

    /**
     * 提交校验
     *    1. 直接校验当前分区
     *    2. 其他分区填写的数据校验
     */
    async submitForm() {
      console.log(this.partitionArr, '------------', this.partitionObj);
      if (!this.isQuotationMethod) {
        // 通用报价（非必填）
        if (!this.partitionArr.length) {
          return true;
        }

        // 存在数据，校验必填项
        const isBool = await this.$refs.defaultTableRef.submitForm();
        if (!isBool) {
          this.$message.warning(this.$t('operatingPlatform.PleaseFillInTheRequiredFields'));
          return false;
        }
        return true;
      }

      // 选择了分区方案/车线方案
      {
        // 校验当前分区
        const isBool = await this.$refs.tableRef.submitForm();

        if (!isBool) {
          this.$message.warning(this.$t('basicData.CheckFail'));
          return false;
        }
      }
      // 存在其他分区，校验
      {
        const arr = [];
        for (const key in this.partitionObj) {
          const isBool = validatePrice(this.partitionObj[key].arr);
          if (!isBool) {
            arr.push(key);
          }
        }
        // 有校验不通过的分区
        const dataList = this.businessType === 5 ? this.stitchingLine : this.subregionList;
        if (arr.length > 0) {
          // 获取不通过的分区名称
          const list = dataList.filter(item => {
            return arr.includes(String(item.id));
          }).map(item => {
            return item.partitionIdentifier;
          }).join(',');

          this.$message.error('其他规则的关联分区《' + list + '》' + this.$t('basicData.CheckFail'));
          return false;
        }
      }
      return true;
    },

    // 设置数据(主要是为父组件提供操作)
    setData(arr) {
      console.log(arr, 'setData其他规则');
      this.pendingDataList = []; // 清空缓存
      if (arr.length === 0) return;

      try {
        // 通用报价
        if (!this.isQuotationMethod) {
          this.partitionArr = arr.map(item => {
            // eslint-disable-next-line no-unused-vars
            const { lineId, partitionAffiliateId, ...restItem } = item;
            return {
              ...restItem,
              feeTypeCode: item.feeTypeCode || '',
              deliveryFeeRatio: item.deliveryFeeRatio || 0.01
            };
          });
          return;
        }
        // 车线/分区报价
        for (const item of arr) {
          const { partitionAffiliateId, lineId } = item;
          const key = this.isTransportBusiness ? lineId : partitionAffiliateId;
          // 排除无效键值
          if (!key) continue;
          if (!this.partitionObj[key]) {
            // 如果分区对象不存在，先初始化
            this.partitionObj[key] = { arr: [] };
          }

          this.partitionObj[key].arr.push(item);
        }
      } catch (error) {
        console.log('其他规则-setData出错:', error);
      }
    },

    // 获取数据
    getData() {
      const arr = [];
      // 通用报价
      if (!this.isQuotationMethod) {
        return this.partitionArr.map(item => {
          return {
            ...TEM_ROW,
            ...item,
            partitionAffiliateId: undefined,
            lineId: undefined,
            businessType: this.businessType
          };
        });
      }

      // 选择了分区/车线，将所有数据（二维数组）放入arr（一维数组）中
      Object.entries(this.partitionObj)
        .filter(([_, partition]) => partition.arr.length > 0)
        .forEach(([affiliateId, partition]) => {
          const list = partition.arr.map(item => ({
            ...TEM_ROW,
            ...item,
            offerPriceId: this.ids,
            partitionId: this.partitionId,
            partitionAffiliateId: affiliateId,
            businessType: this.businessType
          }));
          arr.push(...list);
        });

      console.log(arr, '其他规则-getData-other-463');
      return arr;
    },

    // 下载报价回调函数
    onDownloadOffer() {
      const list = this.getData();

      const buildMapById = (arr) => {
        const map = new Map();
        arr.forEach(item => {
          if (item && typeof item.id !== 'undefined') {
            map.set(item.id, item);
          }
        });
        return map;
      };

      const stitchingLineMap = buildMapById(this.stitchingLine);
      const subregionListMap = buildMapById(this.subregionList);

      const specialFeeMap = new Map();
      this.specialFeeList.forEach(fee => {
        if (fee && fee.code) {
          specialFeeMap.set(fee.code, fee);
        }
      });

      return list.map(item => {
        const { id, partitionAffiliateId, feeTypeCode, deliveryFeeRatio, startNumber, endNumber } = item;

        const obj = {
          id,
          partitionAffiliateId: '', // 分区关联id
          feeTypeCode: '', // 费用类型处理
          startNumber,
          endNumber,
          deliveryFeeRatio: deliveryFeeRatio || 0.01 // 计费规则
        };

        let targetMap;
        let convertedId;

        if (this.businessType === 5) {
          targetMap = stitchingLineMap;
          convertedId = String(partitionAffiliateId);
        } else {
          targetMap = subregionListMap;
          convertedId = Number(partitionAffiliateId);
          if (isNaN(convertedId)) {
            convertedId = null; // 明确无效数字处理
          }
        }

        // 处理分区/车线名称
        if (convertedId !== null && targetMap.has(convertedId)) {
          const partitionAffiliateObj = targetMap.get(convertedId);
          const { partitionIdentifier, id: pid, name } = partitionAffiliateObj || {};
          obj.partitionAffiliateId = `${partitionIdentifier || name || ''}${SEPARATOR}${pid}`;
        }

        // 费用类型处理
        if (specialFeeMap.has(feeTypeCode)) {
          const feeObj = specialFeeMap.get(feeTypeCode);
          obj.feeTypeCode = `${feeObj.name}${SEPARATOR}${feeTypeCode}`;
        }

        return obj;
      });
    },

    // 导入数据
    onImportList(arr) {
      console.log(arr, '其他规则-导入数据-537');

      // 通用报价模式：无需校验其他分区
      if (!this.isQuotationMethod) {
        this.setData(arr);
        return;
      }

      // 车线/分区报价
      const invalidKeys = [];
      for (const key in this.partitionObj) {
        const isBool = validatePrice(this.partitionObj[key].arr);
        if (!isBool) {
          invalidKeys.push(key);
        }
      }
      console.log(invalidKeys, '校验未通过数据');

      if (invalidKeys.length > 0) {
        const dataList = this.businessType === 5 ? this.stitchingLine : this.subregionList;
        const list = dataList.filter(item => invalidKeys.includes(String(item.id)))
          .map(item => item.partitionIdentifier)
          .join(',');

        this.$message.error('其他规则的关联分区《' + list + '》' + this.$t('basicData.CheckFail'));
        return false;
      }

      this.setData(arr);
    },

    /**
     * @description 清空报价
     * @param {Number} type 1:清空当前分区/车线 2:清空所有分区/车线
     */
    clearOffers(type) {
      // 通用报价
      if (!this.isQuotationMethod) {
        this.partitionArr = [];
        return;
      }

      // 车线报价
      if (type === 1) {
        this.partitionObj[this.partitionAffiliateId].arr = [];
      } else {
        for (const key in this.partitionObj) {
          this.partitionObj[key].arr = [];
        }
      }
    }
  }
};
</script>
